<template>
  <div class="post-it" :style="{ borderColor: color }">
    <div class="post-it-header">
      <div class="post-it-title" :style="{ color: color }">
      {{ title }}
      </div>
      <v-btn
        v-if="username === currentUsername || isadmin == 1"
        icon
        @click="removePost"
        class="delete-button"
        :color="color"
        v-ripple
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
    <v-card class="post-it-content">
      <div class="post-it-text" v-html="content"></div>
    </v-card>
    <div class="post-it-footer">
      <div class="post-it-sign" :style="{ color: color }">
        ✍️ {{ username }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostIt',
  props: {
    title: String,
    content: String,
    id: Number,
    username: String,
    currentUsername: String,
    color: String, 
    isadmin: String,
  },
  mounted() {
    console.log('postit color: ', this.color);
  },
  methods: {
    removePost() {
      this.$emit('remove', this.id);
    },
  },
}
</script>

<style scoped>
.post-it {
  border: 2px dashed;
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #9897A7; /* Colore di sfondo leggermente più scuro per migliorare il contrasto */
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Ombra per dare profondità */
  max-width: 800px;
}
.post-it:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
@media (max-width: 600px) {
  .post-it {    
    padding: 10px;
    max-width: 380px;
  }
}
.post-it-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.post-it-title {
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: -15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1001;
  text-decoration: underline;
}
.post-it-content {
  border: 1px;
  background-color: white;
  margin-top: 10px;
  border-radius: 0px;
  padding-bottom: 15px;
  flex-grow: 1;
  border-color: black;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
}
.post-it-text {
  padding: 20px;
  max-width: 100%;
  max-height: 100%;
  overflow: auto; /* Cambiato a 'auto' per permettere lo scorrimento se necessario */
  text-align: left;
  font-size: 14px;
  line-height: 1.2;
}
.post-it-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.post-it-sign {
  font-style: italic;
  font-size: 12px;
}
.delete-button {
  margin-left: 10px;
  transition: transform 0.2s;
}
.delete-button:hover {
  transform: rotate(20deg);
}
</style>
